import { AusActions } from "@aus/Store/AusState";
import DefaultToOneTimeShipToState from "@aus/Store/Components/DefaultToOneTimeShipTo/DefaultToOneTimeShipToState";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type HandlerType = Handler<DefaultToOneTimeShipToState, DispatchProp<AusActions>>;

export const SetupInitialState: HandlerType = props => {
    props.dispatch({
        type: "SetupInitialState/DefaultToOneTimeShipTo",
        parameter: props.parameter,
    });
};

export const chain = [SetupInitialState];

const setUpIntialValueDefaultShipTo = createHandlerChainRunner(chain, "DefaultToOneTimeShipTo");
export default setUpIntialValueDefaultShipTo;